import * as actionTypes from "../actions/types";

const initialState = {};

export const otp = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SEND_OTP_FAIL:
      console.log("SEND_OTP_FAIL", action.payload);
      return {
        ...state,
        error: action.payload
      };

    case actionTypes.SEND_OTP_FAIL_EMAIL:
      console.log("SEND_OTP_FAIL_EMAIL", action.payload);
      return {
        ...state,
        errorEmail: action.payload
      };
    case actionTypes.SEND_OTP_SUCCESS:
      return {
        ...state,
        error: "",
        errorSms: "",
        errorEmail: "",
        sentChannel: action.payload
      };
    default:
      return state;
  }
};
